import React, { useContext, useEffect } from "react";

import { AuthContext } from "features/Auth";
import UserTestingInfo from "features/UserTestingInfo";

import Layout from "hoc/Layout";

import Routes from "components/Routes";
import Loading from "components/Loading";
import TourReplayHint from "components/TourReplayHint";

import "./App.scss";
import "assets/styles/index.scss";
import "assets/styles/print.scss";

const App = ({ loading, checkUserSession, lastActivity, loadedUid, fetchUserOrganization, organization }) => {
    const { user, setUser, setPending } = useContext(AuthContext);
    const { uid, metadata: { lastSignInTime = "" } = {} } = user || {};

    useEffect(() => {
        if (uid && organization?.memberOrgIds && !organization.details) {
            //only handling a single org at the moment

            const { primaryOrg = null, ...restMemberOrgIds } = organization?.memberOrgIds;

            fetchUserOrganization(uid, primaryOrg || Object.keys(restMemberOrgIds)[0]);
        }
    }, [uid, organization]);

    if (loading) return <Loading message="I am loading" />;

    return (
        <>
            {loadedUid && <UserTestingInfo />}
            <TourReplayHint />
            <Layout user={user}>
                <Routes />
            </Layout>
        </>
    );
};

export default App;
